import { inject } from '@angular/core';
import { withCallStatus } from '@ngrx-traits/signals';
import { signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { AppleCallbackCredentials, User } from '@seatix/shared-domain-auth';
import { catchError, EMPTY, pipe, switchMap, tap } from 'rxjs';
import { AuthApiService } from '../auth-api/auth-api.service';

const APPLE_LOGIN_ERROR_MESSAGE =
  'No se pudo completar el inicio de sesión con Apple. Intenta de nuevo.';

export function withAppleAuth() {
  return signalStoreFeature(
    // Depende de la sesión emitida por `withAuthentication`, que debe
    // componerse antes en el store.
    type<{
      methods: {
        setUser: (user: User) => void;
      };
    }>(),
    withCallStatus({
      prop: 'appleLogin',
      errorType: 'string',
    }),
    withMethods((store) => {
      const authApiService = inject(AuthApiService);

      return {
        // Sign in with Apple JS (popup client-side): el front recibe el
        // identity_token del SDK y lo canjea en el callback same-site. La
        // respuesta setea la cookie de sesión y devuelve el usuario — mismo
        // patrón que `socialLogin` (Google GIS).
        appleLogin: rxMethod<AppleCallbackCredentials>(
          pipe(
            switchMap((credentials) => {
              store.setAppleLoginLoading();

              return authApiService.handleAppleCallback(credentials).pipe(
                tap((response) => {
                  store.setUser(response.data);
                  store.setAppleLoginLoaded();
                }),
                catchError((error) => {
                  store.setAppleLoginError(
                    error.userMessage || APPLE_LOGIN_ERROR_MESSAGE,
                  );
                  return EMPTY;
                }),
              );
            }),
          ),
        ),
      };
    }),
  );
}
